module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_ERSCHOEPFUNG.aa6c8725.png";